import { render, staticRenderFns } from "./LocalEstoquePage.vue?vue&type=template&id=6cf820c6&"
import script from "./LocalEstoquePage.vue?vue&type=script&lang=js&"
export * from "./LocalEstoquePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports